import React from 'react'
import { Field } from 'formik'
import { TextField } from '@material-ui/core'
import { Input } from 'sputnik-ui'

const InputComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <Input
    {...field}
    {...props}
    error={touched[field.name] && Boolean(errors[field.name])}
    helperText={errors[field.name] || props.helperText}
  />
)

const FormField = (props) => <Field component={InputComponent} {...props} />

export default FormField
